// Task dueType constants (Tasks.dueType contract — Follow Up/Automations P2).
//
// 'PATHS' is the legacy stored value for automation-backed tasks; 'AUTOMATIONS'
// is the canonical value. Read BOTH as the same family everywhere so stored
// rows keep working across the backend transition (dual-read, contract §17.2).
// 'FOLLOW_UP' is a distinct family — never fold it into automations.

export const AUTOMATION_DUE_TYPES = ['PATHS', 'AUTOMATIONS'];

export const isAutomationDueType = (dueType) => AUTOMATION_DUE_TYPES.includes(dueType);

export const isFollowUpDueType = (dueType) => dueType === 'FOLLOW_UP';

// User-facing labels per Tasks.dueType value (contract "Task type labels").
export const TASK_DUE_TYPE_LABELS = {
    EVENT_VOLUNTEER: 'Volunteer',
    EVENT_SERVICE_FLOW: 'Service Flow',
    INDIVIDUAL: 'Individual',
    TRAINING: 'Training',
    PATHS: 'Automations',
    AUTOMATIONS: 'Automations',
    FOLLOW_UP: 'Follow Up',
};

export const getTaskDueTypeLabel = (dueType) => TASK_DUE_TYPE_LABELS[dueType] || dueType;

export const TASK_DUE_TYPE_ICONS = {
    EVENT_VOLUNTEER: 'people-outline',
    EVENT_SERVICE_FLOW: 'list-outline',
    INDIVIDUAL: 'person-outline',
    TRAINING: 'school-outline',
    PATHS: 'git-branch-outline',
    AUTOMATIONS: 'git-branch-outline',
    FOLLOW_UP: 'heart-outline',
};

export const getTaskDueTypeIcon = (dueType) => TASK_DUE_TYPE_ICONS[dueType] || 'clipboard-outline';
